import { DashboardModal, useUppy } from "@uppy/react";
import Uppy, { UppyFile } from "@uppy/core";
import AwsS3, { AwsS3UploadParameters } from "@uppy/aws-s3";
import "@uppy/core/dist/style.css";
import "./style.css";
import { useEffect, useState } from "react";
import Papa from "papaparse";
import { CSVPreview } from "../../AssetDetail/CSVPreview/CSVPreview";
import { set } from "lodash";

interface UppyModalProps {
  className?: string;
  open: boolean;
  onClose: VoidFunction;
  getUploadParameters:
    | ((
        file: UppyFile<Record<string, unknown>, Record<string, unknown>>
      ) => Promise<AwsS3UploadParameters>)
    | undefined;
}

export default function UppyModal({
  onClose,
  open,
  getUploadParameters,
  className,
}: UppyModalProps) {
  const [data, setData] = useState<any>([]);

  const close = () => {
    setData(undefined);
  };

  const parseCSV = (file: any): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      Papa.parse(file.data, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => resolve(results.data),
        error: (err) => reject(err),
      });
    });
  };

  const uppy = useUppy(() => {
    return new Uppy({
      restrictions: {
        allowedFileTypes: [".csv"],
      },
    })
      .use(AwsS3, {
        getUploadParameters,
      })
      .on("files-added", async (files: any[]) => {
        try {
          const rowData = [];
      
          for (const file of files) {
            if (file.extension === "csv") {
              const parsed = await parseCSV(file);
              rowData.push({id: file.id, rows: parsed});
            }
          }
          setData(rowData);
        } catch (err) {
          console.error("Failed to parse CSV:", err);
        }
      });
  });

  const removeFile = () => {
    if (data.length > 0) {
      data.forEach((row: any) => {
        uppy.removeFile(row.id);
      })
      close();
    }
  };

  const removeFileById = (id: string) => {
    uppy.removeFile(id);
    setData((prev: any) => prev.filter((row: any) => row.id !== id));
  };

  return (
    <>
      <div className={`${className} uppy-modal-wrapper`}>
        <DashboardModal
          uppy={uppy}
          closeModalOnClickOutside
          open={open}
          onRequestClose={onClose}
          locale={{
            strings: {
              uploading: "Processing Data Asset…Generating Metadata…",
            },
          }}
        />
      </div>

      <CSVPreview removeFile={removeFile} parsedData={data} close={close} removeFileById={removeFileById} />
    </>
  );
}
